// extracted by mini-css-extract-plugin
export default {"createProjectBtn":"button_createProjectBtn__+Z0hP"};